import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { LogoComponent } from "./layout/logo/logo.component";
import { AppSettings } from './app.settings';
import { CommonModule } from '@angular/common';
import { ThemeService } from './services/theme.service';
import { PrimeNGConfig } from 'primeng/api';
import { LoginComponent } from "./components/login/login.component";
import { AuthenticationService } from './services/authentication.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, StyleClassModule, BadgeModule, NgIf, ButtonModule, InputTextModule, SelectButtonModule, FormsModule, LogoComponent, CommonModule, LoginComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: []
})
export class AppComponent implements OnInit {

  themeService = inject(ThemeService);
  primeConfig = inject(PrimeNGConfig);
  authenticationService = inject(AuthenticationService);
  router = inject(Router);

  login: boolean = false;

  settings = AppSettings.settings;

  constructor() { }

  ngOnInit(): void {
    console.log("*** ngOnInit AppComponent ***")

    this.primeConfig.ripple = true;
    this.themeService.loadStartupTheme();

    this.primeConfig.setTranslation({
      accept: 'Ja',
      reject: 'Abbrechen',
      firstDayOfWeek: 1,
      dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
      dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      today: 'Heute',
      clear: 'X',
      dateFormat: 'dd.mm.yy'
      //translations
    });

    const chkToken = this.authenticationService.checkTokenIsValid();
  }

  switchTheme(name: string) {
    this.themeService.switchTheme(name);
  }

  title = 'Bettenstar';


}
